export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=e4a8c630&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/profile/index.vue?vue&type=template&id=e4a8c630&
// module id = 1332
// module chunks = 0